import axios from "axios";
import { useEffect, useRef } from "react";

import * as AuthServices from '../../services/auth.service';
import Swal from "sweetalert2";
import { ROLE, SWAL_SETTINGS } from "../../../../utils/Constants";
import { addProfileData } from "../../../../redux/slices/profileslice";
import { clearUserSession, handleServerValidations, setLocalKey, isMissingPhoneNumber } from "../../../../utils/commonfunction";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

export default function GoogleCustomButton() {
    const navigate = useNavigate();
    const Dispatch = useDispatch();

    const hiddenButtonRef = useRef(null);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;

        script.onload = () => {
        window.google.accounts.id.initialize({
            client_id: process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID,
            callback: handleLogin,
        });

        // Render the official button but hide it
        window.google.accounts.id.renderButton(hiddenButtonRef.current, {
            theme: "outline",
            size: "large",
        });
        };

        document.body.appendChild(script);
    }, []);

  const handleLogin = async (response) => {
    const idToken = response.credential;

    const paylaod = {
        id_token: idToken,
        fcm_token: ''
    }
    AuthServices.googleLogin(paylaod)
    .then((response) => {

        if (response.success) {
            clearUserSession();
            setLocalKey(ROLE.USER, JSON.stringify(response.data));
            if (response.data.isAdvertiser || response.data.role === ROLE.ADVERTISER) {
                setLocalKey(ROLE.ADVERTISER, JSON.stringify(response.data));
            }
            Dispatch(addProfileData(response.data));

            if (isMissingPhoneNumber(response.data.phone_number)) {
                Swal.fire({
                    icon: "warning",
                    title: "Mobile Number Required",
                    text: "Please add your mobile number to continue.",
                    confirmButtonColor: "var(--primary-400, #ff4081)",
                    confirmButtonText: "Add Mobile Number",
                }).then(() => {
                    navigate('/user/profile-edit');
                });
                return;
            }

            Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
            });
            navigate('/');

        } else {
            Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
            });
        }
    })
    .catch((error) => {
        console.log("error ====> ", error);
    });

  };

  const triggerLogin = () => {
    // Programmatically click the hidden Google button 
    const btn = hiddenButtonRef.current.firstElementChild;
    console.log(btn, '=======btn');
    if (btn) btn.click();
  };

  {/* Hidden official Google button (required) */}
//   return (
//     <div>
      
//       <button
//         type="button"
//         onClick={triggerLogin}
//         className="flex-1 flex items-center justify-center"
//       >
//         <img src="/images/google.svg" alt="Google"/>
//       </button>

      
//       <div 
//         ref={hiddenButtonRef}  
//         style={{
//             position: "absolute",
//             left: "-9999px",
//             top: 0,
//             pointerEvents: "auto",
//         }}
//        />
//     </div>
//   );
  

    return <div ref={hiddenButtonRef}  />
}
